<template>
    <div class="content-area__content">
        <div class="holiday-manage" v-if="!isLoading">
            <template v-if="width < 2054 && width > 1699">
                <vs-row justify="flex-end">
                    <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
                </vs-row>
            </template>
            <div class="card">
                <div class="card-header">
                    <h2>휴일관리</h2>
                </div>
                <div class="card-body">
                    <div class="flex justify-end flex-wrap mb-3">
                        <vs-button radius color="primary" icon-pack="feather" icon="icon-edit"
                        @click="modifyHoliday('insert', {})" />
                        <!-- <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="onClickModifyView(-1, '')" /> -->
                        <!-- <template v-if="userLevel == 2">
                        <vs-button radius color="primary" icon-pack="feather" icon="icon-upload" @click="openUploadPopup()" />
                        <vs-button radius color="primary" icon-pack="feather" icon="icon-download" @click="listDownload()" />
                        <vs-button radius color="primary" icon-pack="feather" icon="icon-download-cloud" @click="listDownloadEssential()" />
                        <vs-button radius color="primary" icon-pack="feather" icon="icon-message-circle" @click="kakaoAllSend()" />
                        </template> -->
                    </div>
                    <div class="tb_box">
                        <div v-if="!list || list.length === 0" class="no-data">
                            데이터가 없습니다.
                        </div>
                        <table v-else id="list" class="holiday-table">
                            <colgroup>
                                <col width="30%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="20%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="table-header">휴일이름</th>
                                    <th class="table-header">휴일날짜</th>
                                    <th class="table-header">휴일색</th>
                                    <th class="table-header">-</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in list" :key="index">
                                    <td class="table-cell">{{ item.DATE_NAME }}</td>
                                    <td class="table-cell">{{ $moment(item.LOC_DATE).format('YYYY-MM-DD') }}</td>
                                    <td class="table-cell">{{ item.IS_HOLIDAY == 'Y'? '빨강' : '파랑' }}</td>
                                    <td class="table-cell">
                                        <div class="button-container">
                                            <vs-button radius color="primary" icon-pack="feather" icon="icon-edit" @click="modifyHoliday('update', item)" />
                                            <vs-button radius color="danger" icon-pack="feather" icon="icon-trash-2" @click="deleteHoliday(item.DATE_SEQ)" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <vs-pagination 
                        :total="totalPage" 
                        v-model="page" 
                        @change="handlePageChange"
                        :max="7">
                    </vs-pagination>
                </div>
            </div>

            <!-- 휴일등록 팝업 -->
            <vs-popup title="휴일등록 및 수정" :active.sync="holidayPopup">
                <form @submit.prevent>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/2 mb-3">
                            <vs-input class="w-auto" label="휴일 이름" placeholder="휴일 이름 입력" v-model="dateName" />
                        </div>
                        <div class="vx-col w-full lg:w-1/2 ">
                            <label for="" class="vs-select--label">날짜 선택</label>
                            <date-picker name="locDate" v-model="locDate" :locale="'ko'" valueType="format"
                            class="vs-inputx normal w-full"></date-picker>
                        </div>
                        <div class="vx-col w-full lg:w-1/2">
                            <vs-select autocomplete class="w-auto" name="isHoliday" v-model="isHoliday" label="휴일 종류 선택"
                            placeholder="선택해주세요.">
                            <vs-select-item value="Y" text="공휴일(빨강)" />
                            <vs-select-item value="N" text="공휴일(파랑)" />
                            </vs-select>
                        </div>
                    </div>

                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="handleSave()">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="popupClose">닫기</vs-button>
                    </div>
                    
                </form>
            </vs-popup>
        </div>
        <div v-else class="loading-container">
            <vs-loading type="point" />
        </div>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import moment from 'moment';
import * as XLSX from 'xlsx';
import store from '@/store/store';
import dateClass from "@/../util/dateClass";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { EventBus } from '../../../util/vue-event-bus';
import Vue from "vue";
import VueHtml2Canvas from "vue-html2canvas";
Vue.use(VueHtml2Canvas);

export default {
    components: {
        DatePicker,
    },
    data() {
        return {
            page: 1,
            totalPage: 0,
            list: [],
            width: window.innerWidth,
            search: '',
            holidayPopup : false,
            locDate : '',
            isHoliday : 'Y',
            dateName : '',
            dateSeq : 0,
            isLoading: false,
            modifyType: 'insert'
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async init(type) {
            if (type == 'init') {
                this.page = 1;
                this.search = '';
            }
            
            const params = {
                page: this.page,
                search: this.search,
            };
            
            try {
                const { data } = await axiosClass.get('/api/management/getHolidayList', params, true);
                console.log('API 응답 데이터:', data);
                if (data && data.list) {
                    this.list = data.list;
                    this.totalPage = data.pageCount;
                } else {
                    this.list = [];
                    this.totalPage = 0;
                }
            } catch(e) {
                console.error('데이터 로드 실패:', e);
                this.list = [];
                this.totalPage = 0;
            }
        },
        async handlePageChange(newPage) {
            this.page = newPage;
            await this.init();
        },
        async modifyHoliday (type, item) {
            this.holidayPopup = true;
            this.modifyType = type;
            if(type == 'insert'){
                this.locDate = '';
                this.isHoliday = 'Y';
                this.dateName = '';
                this.dateSeq = 0;
            } else {
                this.dateSeq = item.DATE_SEQ;
                this.dateName = item.DATE_NAME;
                this.locDate = item.LOC_DATE.substring(0,4) + '-' + item.LOC_DATE.substring(4,6) + '-' + item.LOC_DATE.substring(6,8);
                this.isHoliday = item.IS_HOLIDAY;
            }
        },
        popupClose () {
            this.holidayPopup = false;
            this.dateSeq = 0;
            this.dateName = '';
            this.locDate = '';
            this.isHoliday = 'Y';
        },
        async handleSave() {
            if(this.modifyType === 'insert') {
                await this.saveContents();
            } else {
                await this.updateHoliday();
            }
        },
        async saveContents () {
            if (this.isLoading) return;
            
            this.isLoading = true;
            
            let jsonData = {
                dateSeq : this.dateSeq,
                dateName : this.dateName,
                locDate : this.locDate.replace(/-/g, ""),
                isHoliday : this.isHoliday
            };

            try {
                const { data } = await axiosClass.post("/api/management/saveHoliday", jsonData);
                
                this.$vs.notify({
                    title: "Success",
                    text: "정상적으로 등록되었습니다.",
                    color: "success",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                });

                // 팝업 닫기 및 데이터 초기화
                this.dateSeq = 0;
                this.dateName = '';
                this.locDate = '';
                this.isHoliday = 'Y';
                this.holidayPopup = false;
                
                // 데이터 새로고침
                await this.init('init');

            } catch (error) {
                console.error("저장 실패:", error);
                this.$vs.notify({
                    title: "Error",
                    text: "등록 중 오류가 발생했습니다.",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x",
                });
            } finally {
                this.isLoading = false;
            }
        },
        async updateHoliday () {
            if (this.isLoading) return;
            
            this.isLoading = true;
            
            let jsonData = {
                dateSeq : this.dateSeq,
                dateName : this.dateName,
                locDate : this.locDate.replace(/-/g, ""),
                isHoliday : this.isHoliday
            };

            try {
                const { data } = await axiosClass.post("/api/management/updateHoliday", jsonData);
                
                this.$vs.notify({
                    title: "Success",
                    text: "정상적으로 등록되었습니다.",
                    color: "success",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                });

                // 팝업 닫기 및 데이터 초기화
                this.dateSeq = 0;
                this.dateName = '';
                this.locDate = '';
                this.isHoliday = 'Y';
                this.holidayPopup = false;
                
                // 데이터 새로고침
                await this.init('init');

            } catch (error) {
                console.error("저장 실패:", error);
                this.$vs.notify({
                    title: "Error",
                    text: "등록 중 오류가 발생했습니다.",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x",
                });
            } finally {
                this.isLoading = false;
            }
        },
        async deleteHoliday (dateSeq) {
            if (this.isLoading) return;
            
            this.isLoading = true;
            
            let jsonData = {
                dateSeq : dateSeq
            };

            try {
                const { data } = await axiosClass.delete("/api/management/deleteHoliday", jsonData);

                this.$vs.notify({
                    title: "Success",
                    text: "정상적으로 삭제되었습니다.",
                    color: "success",
                });

                await this.init('init');
            } catch (error) {
                console.error("삭제 실패:", error);
            } finally {
                this.isLoading = false;
            }
        }
    },
    created() {
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize);
        try {
            await this.init('init');
        } catch (error) {
            console.error('초기 데이터 로드 실패:', error);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.content-area__content {
    width: 100%;
    min-height: 100vh;
    background-color: #f8f8f8;
    padding: 2.2rem;
}

.holiday-manage {
    width: 100%;
    position: relative;
}

.card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin: 0;
    position: relative;
    z-index: 1;
    width: 100%;
}

.card-header {
    padding: 1.5rem;
    border-bottom: 1px solid #eee;
    background-color: white;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.card-header h2 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
}

.card-body {
    padding: 1.5rem;
    background-color: white;
}

.tb_box {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 1rem;
    position: relative;
    background-color: white;
    border-radius: 4px;
}

.no-data {
    text-align: center;
    padding: 2rem;
    background-color: #f8f8f8;
    border: 1px solid #eee;
    border-radius: 4px;
    color: #666;
}

.holiday-table {
    width: 100%;
    min-width: 1400px;
    border-collapse: collapse;
    background-color: white;
    border: 1px solid #eee;
}

.table-header {
    background-color: #f8f8f8;
    font-weight: 600;
    padding: 1rem;
    text-align: center;
    border: 1px solid #eee;
    color: #2c3e50;
}

.table-cell {
    padding: 1rem;
    text-align: center;
    border: 1px solid #eee;
    color: #2c3e50;
}

.flex {
    display: flex;
}

.justify-end {
    justify-content: flex-end;
}

.flex-wrap {
    flex-wrap: wrap;
}

.mb-3 {
    margin-bottom: 1rem;
}

@media screen and (max-width: 1400px) {
    .tb_box {
        overflow-x: auto;
    }
    
    .holiday-table {
        min-width: 1400px;
    }
}

/* vs-button 스타일 오버라이드 */
.vs-button {
    margin: 0.25rem;
}

/* vs-pagination 스타일 오버라이드 */
.vs-pagination {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
}

.loading-container {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f8f8f8;
}

.button-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
}

.button-container .vs-button {
    margin: 0 0.5rem;
}
</style>
